export const MeterIssueTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Log into</span> the <span className="font-semibold">Enphase
                    Enlighten Portal</span> at <a
                    href="https://enlighten.enphaseenergy.com/"
                    target="_blank"
                    rel="noreferrer"
                >https://enlighten.enphaseenergy.com/</a>, <span className="font-semibold">select</span> the
                warranty holder's site from the <span className="font-semibold">systems
                list,</span> and <span className="font-semibold">navigate</span> to
                the <span className="font-semibold">Devices tab</span> for detailed information.
            </li>
            <li>
                Check if the issue is with <span className="font-semibold">CT Measurements</span> (negative
                production or consumption readings) or <span className="font-semibold">Storage
                    Measurements</span> (storage activity not reflected).
            </li>
            <li>
                For CT issues, <span className="font-semibold">inspect</span> <span className="font-semibold">CT
                    orientation and leads</span>. Compare with voltage measurements using your regional troubleshooting
                guide.
            </li>
            <li>
                For Storage issues, <span className="font-semibold">verify wiring</span> to include AC Batteries in
                both production and consumption circuits.
            </li>
            <li>
                The <span className="font-semibold">Meter Issue status</span> will update after 24 hours of
                corrected data.
            </li>
        </ul>
    </div>
